import { useSearchParams } from 'react-router-dom';

export const useSearchParamsString = (): string => {
    const [searchParams] = useSearchParams();
    return searchParams.size > 0 ? `?${searchParams.toString()}` : '';
};
